document.addEventListener('DOMContentLoaded', () => {
    const updateTitles = () => {
        document.querySelectorAll('.boost-pfs-search-suggestion-product-title').forEach((title) => {
            title.innerHTML = title.innerHTML.replace(/&nbsp;/g, ' '); // Replace `&nbsp;` with normal spaces
        });
    };

    // Initial run for already-loaded titles
    updateTitles();

    // Watch for dynamically loaded content using MutationObserver
    const searchResultsContainer = document.querySelector('.boost-pfs-search-suggestion-right');
    if (searchResultsContainer) {
        const observer = new MutationObserver(() => {
            updateTitles();
        });a
        observer.observe(searchResultsContainer, { childList: true, subtree: true });
    }

    setInterval(updateTitles, 500);
});
